import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProject = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.25 6C6.83579 6 6.5 6.33579 6.5 6.75V14.25C6.5 14.6642 6.83579 15 7.25 15C7.66421 15 8 14.6642 8 14.25V6.75C8 6.33579 7.66421 6 7.25 6Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 6C11.5858 6 11.25 6.33579 11.25 6.75V11.25C11.25 11.6642 11.5858 12 12 12C12.4142 12 12.75 11.6642 12.75 11.25V6.75C12.75 6.33579 12.4142 6 12 6Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 6.75C16 6.33579 16.3358 6 16.75 6C17.1642 6 17.5 6.33579 17.5 6.75V16.25C17.5 16.6642 17.1642 17 16.75 17C16.3358 17 16 16.6642 16 16.25V6.75Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.75 2C2.7835 2 2 2.7835 2 3.75V20.25C2 21.2165 2.7835 22 3.75 22H20.25C21.2165 22 22 21.2165 22 20.25V3.75C22 2.7835 21.2165 2 20.25 2H3.75ZM3.5 3.75C3.5 3.61193 3.61193 3.5 3.75 3.5H20.25C20.3881 3.5 20.5 3.61193 20.5 3.75V20.25C20.5 20.3881 20.3881 20.5 20.25 20.5H3.75C3.61193 20.5 3.5 20.3881 3.5 20.25V3.75Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgProject;
